const constantsAuth = {}

export default constantsAuth
